(function(){
  const root = document.querySelector("[data-visor-configurator]");
  if(!root) return;

  const $ = (id) => root.querySelector(`#${id}`);
  const $$ = (selector) => Array.from(root.querySelectorAll(selector));
  const fmt = (n) => Number(n || 0).toLocaleString("en-AU");
  const money = (n) => new Intl.NumberFormat("en-AU",{style:"currency",currency:"AUD"}).format(n || 0);
  const finishSuffix = { black:"B", white:"W", mill:"M" };
  const finishLabel = { black:"Matt Black", white:"Pearl Matt White", mill:"Mill Finish" };
  const mountingLabel = { face:"Face Mount", extended_face:"Extended Baluster Face Mount", deck:"Deck Mount" };
  const unavailableMountings = new Set(["extended_face"]);
  const baseThickness = { face:12, extended_face:12, deck:10 };
  const heightRules = {
    face:{min:1100,max:1220,note:"Measured from finished floor/deck level to the top of the handrail. Face mount: choose 1100mm to 1220mm."},
    extended_face:{min:1000,max:1100,note:"Measured from finished floor/deck level to the top of the handrail. Extended face: choose 1000mm or 1100mm; the elevation shows the selected height."},
    deck:{min:1000,max:1220,note:"Measured from finished floor/deck level to the top of the handrail. Deck mount: choose 1000mm to 1220mm."}
  };
  const windNotes = {
    face:"PTS standard face mount is suitable for Wind Regions A and B up to 25m where the stated terrain and fixing conditions are met. Region C/D or unusual sites need project review.",
    deck:"PTS standard deck mount is suitable for Wind Regions A and B up to 25m where the stated terrain and fixing conditions are met. Region C/D or unusual sites need project review.",
    extended_face:"PTS extended face mount can be used up to less than 50m only in the listed cases: Region A TC1-3, Region B1 TC3, and Region B2 TC3. Lower limits apply to other B/C terrain categories, and Region D is not covered."
  };
  const heightPresets = [1000,1100,1200,1220];
  const extendedFacePlateHeight = 160;
  const extendedBalusterOverhangMm = 100;
  const railDeductMm = 8;
  const sideIds = ["A","B","C"];
  const ENABLE_CART = true;

  const products = {
    "(GO) VIS-4000-FACE-B":{role:"base_profile",label:"Visor 4000mm face-mount L profile - Black",variantId:47096151081271,price:272.09,stock:4000,bundled:"2 bottom-cover extrusions included"},
    "(GO) VIS-4000-FACE-W":{role:"base_profile",label:"Visor 4000mm face-mount L profile - White",variantId:47096151146807,price:272.09,stock:4000,bundled:"2 bottom-cover extrusions included"},
    "(GO) VIS-4000-FACE-M":{role:"base_profile",label:"Visor 4000mm face-mount L profile - Mill",variantId:47096151179575,price:260,stock:4000,bundled:"2 bottom-cover extrusions included"},
    "(GO) VIS-4000-DECK-B":{role:"base_profile",label:"Visor 4000mm deck-mount T profile - Black",variantId:47095353114935,price:301.11,stock:4000,bundled:"side cover included"},
    "(GO) VIS-4000-DECK-W":{role:"base_profile",label:"Visor 4000mm deck-mount T profile - White",variantId:47095353147703,price:301.11,stock:4000,bundled:"side cover included"},
    "(GO) VIS-4000-DECK-M":{role:"base_profile",label:"Visor 4000mm deck-mount T profile - Mill",variantId:47095353180471,price:289.01,stock:4000,bundled:"side cover included"},
    "(GO) VIS-4000-FACEPLATE-B":{role:"base_profile",label:"Visor 4000mm extended face plate - Black",variantId:null,stock:4000,review:true},
    "(GO) VIS-4000-FACEPLATE-W":{role:"base_profile",label:"Visor 4000mm extended face plate - White",variantId:null,stock:4000,review:true},
    "(GO) VIS-4000-FACEPLATE-M":{role:"base_profile",label:"Visor 4000mm extended face plate - Mill",variantId:null,stock:4000,review:true},
    "(GO) VIS-1200-BAL-B-4PK":{role:"standard_baluster_pack",label:"1200mm 50 x 10mm baluster pack of 4 - Black",variantId:47094839050551,price:78.61,stock:1200,pack:4},
    "(GO) VIS-1200-BAL-W-4PK":{role:"standard_baluster_pack",label:"1200mm 50 x 10mm baluster pack of 4 - White",variantId:47094839083319,price:78.61,stock:1200,pack:4},
    "(GO) VIS-1200-BAL-M-4PK":{role:"standard_baluster_pack",label:"1200mm 50 x 10mm baluster pack of 4 - Mill",variantId:47094839116087,price:66.51,stock:1200,pack:4},
    "(GO) VIS-6100-BAL-B":{role:"long_baluster",label:"6100mm 50 x 10mm baluster extrusion - Black",variantId:47095141007671,price:82.35,stock:6100,review:true},
    "(GO) VIS-6100-BAL-W":{role:"long_baluster",label:"6100mm 50 x 10mm baluster extrusion - White",variantId:47095141040439,price:82.35,stock:6100,review:true},
    "(GO) VIS-6100-BAL-M":{role:"long_baluster",label:"6100mm 50 x 10mm baluster extrusion - Mill",variantId:47095141073207,price:69.67,stock:6100,review:true},
    "(GO) VIS-6100-HRAIL-B":{role:"handrail",label:"6100mm 70 x 23mm handrail - Black",variantId:47097430671671,price:100.08,stock:6100},
    "(GO) VIS-6100-HRAIL-W":{role:"handrail",label:"6100mm 70 x 23mm handrail - White",variantId:47097430704439,price:100.08,stock:6100},
    "(GO) VIS-6100-HRAIL-M":{role:"handrail",label:"6100mm 70 x 23mm handrail - Mill",variantId:47097430638903,price:93.75,stock:6100},
    "(GO) VIS-4000-PLATE-B":{role:"undercapping",label:"4000mm slotted undercapping plate - Black",variantId:47096666194231,price:78.61,stock:4000},
    "(GO) VIS-4000-PLATE-W":{role:"undercapping",label:"4000mm slotted undercapping plate - White",variantId:47096666226999,price:78.61,stock:4000},
    "(GO) VIS-4000-PLATE-M":{role:"undercapping",label:"4000mm slotted undercapping plate - Mill",variantId:47096666128695,price:70.14,stock:4000},
    "(GO) VIS-4942-PLATE-R-B":{role:"undercapping",label:"4942mm R plate - Black",variantId:47097314672951,stock:4942},
    "(GO) VIS-4942-PLATE-R-W":{role:"undercapping",label:"4942mm R plate - White",variantId:47097314705719,stock:4942},
    "(GO) VIS-4942-PLATE-R-M":{role:"undercapping",label:"4942mm R plate - Mill",variantId:47097314640183,stock:4942},
    "(GO) VIS-3050-INS-2PK":{role:"friction_insert",label:"3050mm friction insert pack of 2",variantId:47097378865463,price:30.23,stock:6100,pack:2},
    "(GO) VIS-FMEP-B-2PK":{role:"base_end_plate",label:"Face-mount end plates pack of 2 - Black",variantId:47112627880247,price:7.26,pack:2},
    "(GO) VIS-FMEP-W-2PK":{role:"base_end_plate",label:"Face-mount end plates pack of 2 - White",variantId:47112627913015,price:7.26,pack:2},
    "(GO) VIS-FMEP-M-2PK":{role:"base_end_plate",label:"Face-mount end plates pack of 2 - Mill",variantId:47112627847479,price:6.66,pack:2},
    "(GO) VIS-DMEP-B-2PK":{role:"base_end_plate",label:"Deck-mount end plates pack of 2 - Black",variantId:47112541110583,price:7.26,pack:2},
    "(GO) VIS-DMEP-W-2PK":{role:"base_end_plate",label:"Deck-mount end plates pack of 2 - White",variantId:47112541143351,price:7.26,pack:2},
    "(GO) VIS-DMEP-M-2PK":{role:"base_end_plate",label:"Deck-mount end plates pack of 2 - Mill",variantId:47112541077815,price:6.66,pack:2},
    "(GO) VIS-FPEP-B-2PK":{role:"base_end_plate",label:"Extended face-plate end plates pack of 2 - Black",variantId:null,pack:2,review:true},
    "(GO) VIS-FPEP-W-2PK":{role:"base_end_plate",label:"Extended face-plate end plates pack of 2 - White",variantId:null,pack:2,review:true},
    "(GO) VIS-FPEP-M-2PK":{role:"base_end_plate",label:"Extended face-plate end plates pack of 2 - Mill",variantId:null,pack:2,review:true},
    "(GO) VIS-EP-B":{role:"handrail_end_plate",label:"70 x 23mm handrail end plate - Black",variantId:47097569935671,price:4.84},
    "(GO) VIS-EP-W":{role:"handrail_end_plate",label:"70 x 23mm handrail end plate - White",variantId:47097569968439,price:4.84},
    "(GO) VIS-EP-M":{role:"handrail_end_plate",label:"70 x 23mm handrail end plate - Mill",variantId:47097569902903,price:3.63},
    "(GO) VIS-WB-B":{role:"wall_bracket",label:"63 x 20mm wall/post bracket - Black",variantId:47112431173943,price:6.05},
    "(GO) VIS-WB-W":{role:"wall_bracket",label:"63 x 20mm wall/post bracket - White",variantId:47112431206711,price:6.05},
    "(GO) VIS-WB-M":{role:"wall_bracket",label:"63 x 20mm wall/post bracket - Mill",variantId:47112431141175,price:4.84},
    "(GO) VIS-BRACKET-B-2PK":{role:"offset_bracket",label:"Offset handrail bracket 2 pack - Black",variantId:47097490932023,price:18.14,pack:2},
    "(GO) VIS-BRACKET-W-2PK":{role:"offset_bracket",label:"Offset handrail bracket 2 pack - White",variantId:47097490964791,price:18.14,pack:2},
    "(GO) VIS-BRACKET-M-2PK":{role:"offset_bracket",label:"Offset handrail bracket 2 pack - Mill",variantId:47097490899255,price:15.72,pack:2},
    "(GO) VIS-J-M":{role:"inline_joiner",label:"Mill inline handrail/friction insert joiner",variantId:47112688927031,price:10.88},
    "(GO) VIS-J90-M":{role:"corner_joiner",label:"Mill 90 degree handrail/friction insert joiner",variantId:47112773173559,price:10.88},
    "(GO) VIS-BAL-EC-B-40PK":{role:"baluster_end_cap",label:"Extended baluster end cap pack of 40 - Black",variantId:null,pack:40,review:true},
    "(GO) VIS-BAL-EC-W-40PK":{role:"baluster_end_cap",label:"Extended baluster end cap pack of 40 - White",variantId:null,pack:40,review:true},
    "(GO) VIS-BAL-EC-M-40PK":{role:"baluster_end_cap",label:"Extended baluster end cap pack of 40 - Mill",variantId:null,pack:40,review:true},
    "(GO) VIS-SCR-BAL-50PK":{role:"baluster_screw",label:"12G x 50mm panhead screw pack of 50",variantId:47112903917879,price:10.88,pack:50},
    "(GO) VIS-SCR-SIDEBAL-50PK":{role:"side_top_screw",label:"14G x 50mm panhead screw pack of 50",variantId:47112933933367,price:10.88,pack:50},
    "(GO) VIS-SCR-CSK-50PK-B":{role:"countersunk_screw",label:"8G x 25mm countersunk screw pack of 50 - Black",variantId:47112973287735,price:6.05,pack:50},
    "(GO) VIS-SCR-CSK-50PK-W":{role:"countersunk_screw",label:"8G x 25mm countersunk screw pack of 50 - White",variantId:47112973320503,price:6.05,pack:50},
    "(GO) VIS-SCR-CSK-50PK":{role:"countersunk_screw",label:"8G x 25mm countersunk screw pack of 50 - Mill",variantId:47112973254967,price:4.84,pack:50},
    "(GO) CSK-12GX25-20PK":{role:"extended_end_cap_screw",label:"12G x 25mm countersunk screw pack of 20 - Mill",variantId:null,pack:20,review:true},
    "(GO) CSK-12GX25-B-20PK":{role:"extended_end_cap_screw",label:"12G x 25mm countersunk screw pack of 20 - Black",variantId:null,pack:20,review:true},
    "(GO) GS093LAG":{role:"extra",label:"93mm M12 lag screw",variantId:29952223281255,price:3.58},
    "(GO) GS115LAG":{role:"extra",label:"115mm M12 lag screw",variantId:29952223314023,price:3.58},
    "(GO) GS160LAG":{role:"extra",label:"160mm M12 lag screw",variantId:29952223346791,price:6.04},
    "(GO) GS120ROD":{role:"extra",label:"120mm M12 threaded rod",variantId:32913045684327,price:1.85},
    "(GO) GS1000ROD":{role:"extra",label:"1000mm M12 threaded rod",variantId:32913045717095,price:19.04},
    "(GO) SOUD-CA1400":{role:"extra",label:"Soudal CA-1400 anchoring resin",variantId:32913045586023,price:30.69},
    "(GO) SOUD-GUN":{role:"extra",label:"Soudal applicator gun",variantId:32913052139623,price:59.86},
    "(GO) GS-DN-4PK":{role:"extra",label:"M12 dome nut and split washer pack of 4 - Stainless",variantId:32913048764519,price:3.02,pack:4},
    "(GO) GS-DN-4PK-B":{role:"extra",label:"M12 dome nut and split washer pack of 4 - Black",variantId:47113123692855,price:5.60,pack:4},
    "(GO) HSP-75X38-1MM-20PK":{role:"extra",label:"1mm horseshoe packers pack of 20",variantId:39663073493095,price:3.29,pack:20},
    "(GO) HSP-75X38-3MM-20PK":{role:"extra",label:"3mm horseshoe packers pack of 20",variantId:39663073525863,price:5.49,pack:20},
    "(GO) DB-PH3":{role:"extra",label:"Phillips driver bit",variantId:39534472036455},
    "(GO)DB-SQ2.4-SQ3.4":{role:"extra",label:"Square driver bit",variantId:44369345675575},
    "Crane Truck delivery":{role:"delivery",label:"Crane Truck delivery",variantId:49829588271415}
  };

  const extras = [
    ["(GO) GS093LAG","Optional M12 timber lag screw. Installer or engineer must confirm suitability."],
    ["(GO) GS115LAG","Optional M12 timber lag screw. Installer or engineer must confirm suitability."],
    ["(GO) GS160LAG","Optional M12 timber lag screw. Installer or engineer must confirm suitability."],
    ["(GO) GS1000ROD","Optional 1000mm M12 threaded rod. Quantity/cut use must be confirmed."],
    ["(GO) SOUD-CA1400","Optional anchoring resin. Fixing design and embedment must be confirmed."],
    ["(GO) SOUD-GUN","Optional resin applicator gun."],
    ["(GO) HSP-75X38-1MM-20PK","Optional 1mm packers, pack of 20."],
    ["(GO) HSP-75X38-3MM-20PK","Optional 3mm packers, pack of 20."],
    ["(GO) GS-DN-4PK","Optional stainless dome nuts and split washers, pack of 4."],
    ["(GO) GS-DN-4PK-B","Optional black dome nuts and split washers, pack of 4."],
    ["(GO) DB-PH3","Optional Phillips driver bit."],
    ["(GO)DB-SQ2.4-SQ3.4","Optional square driver bit."],
  ];
  const allowedExtraSkus = new Set(extras.map(([sku]) => sku));

  function calculateSubstrateFixingPlan(runs, mounting){
    const spacingMm = mounting === "extended_face" ? 400 : 300;
    const anchorsPerStation = mounting === "extended_face" ? 2 : 1;
    const stations = runs.reduce((sum,run)=>sum + Math.max(2, Math.ceil(run.lengthMm / spacingMm) + 1), 0);
    return {
      spacingMm,
      stations,
      anchorsPerStation,
      totalAnchors:stations * anchorsPerStation
    };
  }

  function extraRecommendation(sku, plan){
    const anchors = Math.max(1, plan.totalAnchors);
    const stations = Math.max(1, plan.stations);
    const fixingBasis = `${fmt(plan.stations)} fixing stations at ${fmt(plan.spacingMm)}mm max centres, ${plan.anchorsPerStation} M12 fixing${plan.anchorsPerStation === 1 ? "" : "s"} per station`;
    if(["(GO) GS093LAG","(GO) GS115LAG","(GO) GS160LAG"].includes(sku)){
      return {
        quantity:anchors,
        exactQuantity:anchors,
        note:`One lag screw per required M12 fixing point, based on ${fixingBasis}. Confirm timber substrate suitability.`
      };
    }
    if(sku === "(GO) GS1000ROD"){
      return {
        quantity:Math.ceil(anchors / 4),
        exactQuantity:anchors,
        note:`Estimated as one 1000mm threaded rod per 4 M12 anchor studs, based on ${fixingBasis}. Confirm cut length and embedment.`
      };
    }
    if(sku === "(GO) SOUD-CA1400"){
      return {
        quantity:Math.ceil(anchors / 15),
        exactQuantity:anchors,
        note:`Estimated at 1 tube per 15 M12 chemical anchors, based on ${fixingBasis}. Confirm hole depth, wastage and site conditions.`
      };
    }
    if(sku === "(GO) SOUD-GUN"){
      return {quantity:1, exactQuantity:1, note:"One applicator gun when chemical anchor is selected."};
    }
    if(["(GO) GS-DN-4PK","(GO) GS-DN-4PK-B"].includes(sku)){
      return {
        quantity:Math.ceil(anchors / 4),
        exactQuantity:anchors,
        note:`Dome nuts are supplied in packs of 4; quantity is based on ${fmt(anchors)} M12 fixing points.`
      };
    }
    if(["(GO) HSP-75X38-1MM-20PK","(GO) HSP-75X38-3MM-20PK"].includes(sku)){
      return {
        quantity:Math.ceil(stations / 20),
        exactQuantity:stations,
        note:`Packers are supplied in packs of 20; estimated as one packer position per fixing station.`
      };
    }
    return {quantity:1, exactQuantity:1, note:"One optional driver/tool selected by customer."};
  }

  const state = {
    schemaVersion:1,
    systemType:"visor_aluminium_balustrade",
    projectName:"Visor aluminium balustrade",
    mounting:"face",
    finish:"black",
    sideCount:1,
    activeSide:0,
    runs:[{id:"A",lengthMm:4000},{id:"B",lengthMm:2500},{id:"C",lengthMm:2500}],
    leftEnd:"open",
    rightEnd:"open",
    finishedHeightMm:1200,
    faceDropMm:160,
    selectedExtras:{},
    view:"elevation"
  };

  function splitStock(length, stock){
    const pieces = [];
    let remaining = Math.max(0, Math.round(length));
    while(remaining > 0){
      const next = Math.min(stock, remaining);
      pieces.push(next);
      remaining -= next;
    }
    return pieces.length ? pieces : [0];
  }

  function runLayout(run){
    const length = Math.max(0, Math.round(run.lengthMm));
    const balusters = Math.max(2, Math.ceil(length / 100));
    const occupied = (balusters * 10) + ((balusters - 1) * 90);
    const endGap = Math.round(((length - occupied) / 2) * 10) / 10;
    const firstCenter = endGap + 5;
    return {
      id:run.id,
      lengthMm:length,
      balusterCount:balusters,
      endGapMm:endGap,
      clearOpeningMm:90,
      centers:Array.from({length:balusters},(_,i)=>Math.round((firstCenter + i * 100) * 10) / 10),
      basePieces:splitStock(length,4000),
      handrailPieces:splitStock(length,6100)
    };
  }

  function productSku(base){
    const s = finishSuffix[state.finish];
    if(base === "VIS-SCR-CSK-50PK") return state.finish === "mill" ? "(GO) VIS-SCR-CSK-50PK" : `(GO) VIS-SCR-CSK-50PK-${s}`;
    return `(GO) ${base}-${s}`;
  }

  function add(lines, sku, qty, exact, note, review){
    if(!qty || qty < 1) return;
    const product = products[sku] || {role:"extra",label:sku,variantId:null,review:true};
    lines.push({
      role:product.role,
      label:product.label || sku,
      sku,
      quantity:qty,
      exactQuantity:exact,
      variantId:product.variantId || null,
      price:product.price,
      stock:product.stock,
      pack:product.pack,
      review:!!review || !!product.review || !product.variantId,
      notes:[note, product.bundled ? `${product.bundled}; no separate replacement cover added.` : ""].filter(Boolean)
    });
  }

  function calculate(){
    const runs = state.runs.slice(0,state.sideCount).map(runLayout);
    const totalLength = runs.reduce((sum,run)=>sum+run.lengthMm,0);
    const totalBalusters = runs.reduce((sum,run)=>sum+run.balusterCount,0);
    const baseProfileCount = runs.reduce((sum,run)=>sum+Math.ceil(run.lengthMm/4000),0);
    const handrailCount = runs.reduce((sum,run)=>sum+Math.ceil(run.lengthMm/6100),0);
    const openEnds = (state.leftEnd === "open" ? 1 : 0) + (state.rightEnd === "open" ? 1 : 0);
    const wallEnds = (state.leftEnd === "wall" ? 1 : 0) + (state.rightEnd === "wall" ? 1 : 0);
    const offsetEnds = (state.leftEnd === "offset" ? 1 : 0) + (state.rightEnd === "offset" ? 1 : 0);
    const corners = state.sideCount - 1;
    const standardBalusterLength = Math.min(1200, state.finishedHeightMm - baseThickness[state.mounting] - railDeductMm);
    const extendedBalusterLength = state.finishedHeightMm + extendedFacePlateHeight + extendedBalusterOverhangMm - railDeductMm;
    const balusterCutLength = state.mounting === "extended_face" ? extendedBalusterLength : standardBalusterLength;
    const extendedBalustersPerLength = Math.max(1, Math.floor(6100 / extendedBalusterLength));
    const extendedBalusterStockCount = state.mounting === "extended_face" ? Math.ceil(totalBalusters / extendedBalustersPerLength) : 0;
    const substrateFixingPlan = calculateSubstrateFixingPlan(runs, state.mounting);
    const validation = ["VIS_COMPLIANCE_REVIEW"];
    runs.forEach(run => {
      const spacingOk = run.centers.every((center,index,centers)=>index === 0 || Math.round((center - centers[index-1]) * 10) / 10 === 100);
      if(!spacingOk) validation.push("VIS_INVALID_BALUSTER_SPACING");
      if(run.clearOpeningMm !== 90) validation.push("VIS_OVERSIZED_OPENING");
      if(run.endGapMm < 0 || run.endGapMm > 90) validation.push("VIS_UNSUPPORTED_END_CLEARANCE");
    });
    if(state.mounting === "extended_face"){
      if(state.finishedHeightMm > 1100) validation.push("VIS_HEIGHT_REVIEW");
    } else if(state.mounting === "deck" && (state.finishedHeightMm < 1000 || state.finishedHeightMm > 1220)){
      validation.push("VIS_HEIGHT_REVIEW");
    } else if(state.mounting === "face" && (state.finishedHeightMm < 1100 || state.finishedHeightMm > 1220)){
      validation.push("VIS_HEIGHT_REVIEW");
    }

    const s = finishSuffix[state.finish];
    const lines = [];
    const baseSku = state.mounting === "deck" ? `(GO) VIS-4000-DECK-${s}` : state.mounting === "extended_face" ? `(GO) VIS-4000-FACEPLATE-${s}` : `(GO) VIS-4000-FACE-${s}`;
    add(lines, baseSku, baseProfileCount, undefined, `4000mm pre-machined profile. Cut pieces: ${runs.flatMap(r=>r.basePieces).map(n=>`${n}mm`).join(", ")}`);

    if(state.mounting === "extended_face"){
      add(lines, `(GO) VIS-6100-BAL-${s}`, extendedBalusterStockCount, totalBalusters, `${totalBalusters} exact extended balusters cut to ${balusterCutLength}mm from 6100mm stock. Allows ${extendedBalustersPerLength} balusters per full length before saw allowance.`);
    } else {
      add(lines, `(GO) VIS-1200-BAL-${s}-4PK`, Math.ceil(totalBalusters/4), totalBalusters, `${totalBalusters} exact balusters cut to ${balusterCutLength}mm from 1200mm stock. Sold in packs of 4.`);
    }

    add(lines, `(GO) VIS-6100-HRAIL-${s}`, handrailCount, undefined, `6100mm rectangular handrail. Cut pieces: ${runs.flatMap(r=>r.handrailPieces).map(n=>`${n}mm`).join(", ")}`);
    add(lines, `(GO) VIS-4000-PLATE-${s}`, baseProfileCount, undefined, "4000mm slotted undercapping plate at 100mm centres.");
    add(lines, "(GO) VIS-3050-INS-2PK", handrailCount, undefined, "Two 3050mm inserts per pack, total 6100mm.");

    const endPlateSku = state.mounting === "deck" ? `(GO) VIS-DMEP-${s}-2PK` : state.mounting === "extended_face" ? `(GO) VIS-FPEP-${s}-2PK` : `(GO) VIS-FMEP-${s}-2PK`;
    add(lines, endPlateSku, Math.ceil(openEnds/2), openEnds, "Base profile end plates for exposed/open base profile ends. Sold in 2-packs; internal stock joins do not need end plates.");
    add(lines, `(GO) VIS-EP-${s}`, openEnds, openEnds, "Handrail end plates for open-end terminations.");
    add(lines, `(GO) VIS-WB-${s}`, wallEnds, wallEnds, "Wall/post brackets for wall terminations. Wall fixings not supplied.");
    add(lines, `(GO) VIS-BRACKET-${s}-2PK`, Math.ceil(offsetEnds/2), offsetEnds, "Offset handrail brackets for offset/return end terminations.");
    add(lines, "(GO) VIS-J90-M", corners, corners, "Mill 90 degree joiner for verified square corners.");
    const inlineJoins = runs.reduce((sum,run)=>sum + Math.max(0, run.basePieces.length - 1), 0);
    add(lines, "(GO) VIS-J-M", inlineJoins, inlineJoins, "Mill inline joiner where base/handrail stock lengths join within a side.");

    if(state.mounting === "extended_face"){
      add(lines, "(GO) VIS-SCR-SIDEBAL-50PK", Math.ceil((totalBalusters*3)/50), totalBalusters*3, "Three 14G x 50 screws per baluster into the extended face plate.");
    } else {
      add(lines, "(GO) VIS-SCR-BAL-50PK", Math.ceil((totalBalusters*2)/50), totalBalusters*2, "Two underside 12G x 50 screws per baluster.");
      add(lines, "(GO) VIS-SCR-SIDEBAL-50PK", Math.ceil((totalBalusters*2)/50), totalBalusters*2, "One base-side fixing and one upper friction-plate fixing per baluster.");
    }

    const cskExact = (openEnds + wallEnds + offsetEnds) * 2;
    add(lines, productSku("VIS-SCR-CSK-50PK"), Math.ceil(cskExact/50), cskExact, "Countersunk screws for handrail end plates, wall/post brackets and offset brackets.");
    add(lines, "Crane Truck delivery", 1, 1, "Crane truck delivery included as a cart line. Delivery area, access and unloading point still need confirmation.");

    Object.entries(state.selectedExtras).forEach(([sku,selected]) => {
      if(!allowedExtraSkus.has(sku)) return;
      if(selected){
        const recommendation = extraRecommendation(sku, substrateFixingPlan);
        add(lines, sku, recommendation.quantity, recommendation.exactQuantity, recommendation.note);
      }
    });

    lines.forEach(line => {
      if(line.review || !line.variantId) validation.push("VIS_MISSING_VARIANT");
      if(line.role === "extra") validation.push("VIS_UNVERIFIED_FIXING");
    });

    const cartBlockingValidation = validation.filter(code => code === "VIS_MISSING_VARIANT" || code === "VIS_HEIGHT_REVIEW" || code === "VIS_INVALID_BALUSTER_SPACING" || code === "VIS_OVERSIZED_OPENING" || code === "VIS_UNSUPPORTED_END_CLEARANCE");
    const price = lines.reduce((sum,line)=>sum + (line.price || 0) * line.quantity, 0);
    return {
      state:JSON.parse(JSON.stringify(state)),
      runs,totalLength,totalBalusters,baseProfileCount,handrailCount,
      openEnds,wallEnds,offsetEnds,corners,balusterCutLength,extendedBalusterLength,
      substrateFixingPlan,
      lines,
      validation:Array.from(new Set(validation)),
      cartBlockingValidation:Array.from(new Set(cartBlockingValidation)),
      price,
      canAddToCart:ENABLE_CART && cartBlockingValidation.length === 0 && !unavailableMountings.has(state.mounting)
    };
  }

  function sideLabel(index){
    return `Side ${sideIds[index]}`;
  }

  function endLabel(value){
    if(value === "wall") return "wall bracket";
    if(value === "offset") return "offset bracket";
    return "end plate";
  }

  function activeRun(){
    return state.runs[state.activeSide];
  }

  function clampHeightForMounting(){
    const rule = heightRules[state.mounting] || heightRules.face;
    state.finishedHeightMm = Math.min(rule.max, Math.max(rule.min, Number(state.finishedHeightMm || rule.min)));
  }

  function renderHeightOptions(){
    const wrap = $("visorHeightOptions");
    if(!wrap) return;
    const rule = heightRules[state.mounting] || heightRules.face;
    wrap.innerHTML = heightPresets.map(value => {
      const disabled = value < rule.min || value > rule.max;
      const active = Number(state.finishedHeightMm) === value;
      return `<button type="button" data-height-option="${value}" class="${active ? "active" : ""}" ${disabled ? "disabled" : ""}>${value === 1220 ? "1220 Max" : `${value}mm`}</button>`;
    }).join("");
  }

  function drawElevation(layout){
    const run = layout.runs[state.activeSide] || layout.runs[0];
    const w = 1040;
    const h = 660;
    const pad = 88;
    const width = w - pad * 2;
    const scale = width / Math.max(run.lengthMm, 4000);
    const drawWidth = run.lengthMm * scale;
    const railX = pad + (width - drawWidth) / 2;
    const railEndX = railX + drawWidth;
    const compactRun = drawWidth < 360;
    const handrailY = 104;
    const handrailHeight = 16;
    const balusterTopY = handrailY + handrailHeight;
    const isDeck = state.mounting === "deck";
    const isExtended = state.mounting === "extended_face";
    const bottomRailY = isDeck ? 360 : isExtended ? 358 : 382;
    const bottomRailHeight = isExtended ? 44 : isDeck ? 12 : 30;
    const balusterBottomY = bottomRailY + bottomRailHeight;
    const overhangPx = isExtended ? extendedBalusterOverhangMm * (bottomRailHeight / extendedFacePlateHeight) : 0;
    const balusterVisualBottomY = balusterBottomY + overhangPx;
    const slabY = isDeck ? bottomRailY + bottomRailHeight : bottomRailY;
    const slabHeight = isDeck ? 58 : isExtended ? 134 : 92;
    const floorY = slabY + slabHeight;
    const baseLabel = state.mounting === "deck" ? "Deck-mount T profile" : state.mounting === "extended_face" ? "Extended face plate" : "Face-mount L profile";
    const facePlateLabel = isDeck ? "" : isExtended ? "160mm face plate" : "101mm face plate";
    const facePlateBoxWidth = isExtended ? 174 : 164;
    const facePlateBoxX = railX + 18;
    const facePlateBoxY = bottomRailY + bottomRailHeight + 14;
    const facePlateCallout = facePlateLabel ? `<line x1="${railX-18}" y1="${bottomRailY}" x2="${railX-18}" y2="${balusterBottomY}" class="dim-line"/><line x1="${railX-24}" y1="${bottomRailY}" x2="${railX-12}" y2="${bottomRailY}" class="dim-line"/><line x1="${railX-24}" y1="${balusterBottomY}" x2="${railX-12}" y2="${balusterBottomY}" class="dim-line"/><line x1="${facePlateBoxX+18}" y1="${facePlateBoxY}" x2="${railX+8}" y2="${bottomRailY+bottomRailHeight/2}" class="dim-line"/><rect x="${facePlateBoxX}" y="${facePlateBoxY}" width="${facePlateBoxWidth}" height="34" rx="8" fill="#fbfdfc" stroke="#10201d" stroke-width="2"/><text x="${facePlateBoxX+12}" y="${facePlateBoxY+22}" fill="#10201d" font-size="15" font-weight="800">${facePlateLabel}</text>` : "";
    const overhangBoxX = Math.min(railEndX + 32, w - 184);
    const overhangCallout = isExtended ? `<line x1="${railEndX+18}" y1="${balusterBottomY}" x2="${railEndX+18}" y2="${balusterVisualBottomY}" class="dim-line"/><line x1="${railEndX+10}" y1="${balusterBottomY}" x2="${railEndX+26}" y2="${balusterBottomY}" class="dim-line"/><line x1="${railEndX+10}" y1="${balusterVisualBottomY}" x2="${railEndX+26}" y2="${balusterVisualBottomY}" class="dim-line"/><rect x="${overhangBoxX}" y="${balusterBottomY + overhangPx / 2 - 17}" width="158" height="34" rx="8" fill="#fbfdfc" stroke="#10201d" stroke-width="2"/><text x="${overhangBoxX+12}" y="${balusterBottomY + overhangPx / 2 + 5}" fill="#10201d" font-size="14" font-weight="900">${extendedBalusterOverhangMm}mm overhang</text>` : "";
    const fflY = slabY;
    const heightBoxY = (handrailY + fflY) / 2 - 21;
    const heightLabel = `${fmt(state.finishedHeightMm)}mm top of handrail`;
    const balusters = run.centers.map((center,i) => {
      const x = railX + center * scale;
      return `<rect x="${x-2.5}" y="${balusterTopY}" width="5" height="${balusterVisualBottomY - balusterTopY}" rx="2.5" fill="#18342e"/>${compactRun ? "" : `<text x="${x}" y="${floorY+38}" text-anchor="middle" class="svg-text tiny">${i+1}</text>`}`;
    }).join("");
    const joinMarks = [];
    let cursor = 0;
    run.basePieces.forEach((piece,index) => {
      if(index){
        const x = railX + cursor * scale;
        joinMarks.push(`<line x1="${x}" y1="${bottomRailY-8}" x2="${x}" y2="${floorY+18}" class="join-line"/><text x="${x}" y="${floorY+60}" text-anchor="middle" class="svg-text small">profile join</text>`);
      }
      cursor += piece;
    });
    return `<svg viewBox="0 0 ${w} ${h}" role="img" aria-label="Visor elevation drawing">
      <rect x="0" y="0" width="${w}" height="${h}" fill="#fbfdfc"/>
      <text x="${w/2}" y="44" text-anchor="middle" class="title-text">${fmt(run.lengthMm)}mm ${mountingLabel[state.mounting]} run</text>
      <line x1="${railX}" y1="72" x2="${railEndX}" y2="72" class="dim-line"/><line x1="${railX}" y1="62" x2="${railX}" y2="82" class="dim-line"/><line x1="${railEndX}" y1="62" x2="${railEndX}" y2="82" class="dim-line"/>
      <rect x="${railX-28}" y="${slabY}" width="${drawWidth+56}" height="${slabHeight}" fill="#d9d4c6" stroke="#928c80"/>
      ${isDeck ? `<line x1="${railX-28}" y1="${slabY}" x2="${railEndX+28}" y2="${slabY}" stroke="#aaa394" stroke-width="3"/>` : `<text x="${railX-40}" y="${slabY+42}" text-anchor="end" class="svg-text small">concrete slab</text>`}
      ${balusters}
      <rect x="${railX}" y="${handrailY}" width="${drawWidth}" height="${handrailHeight}" rx="5" fill="#10201d"/>
      <rect x="${railX}" y="${bottomRailY}" width="${drawWidth}" height="${bottomRailHeight}" rx="5" fill="#10201d"/>
      ${facePlateCallout}
      ${overhangCallout}
      ${joinMarks.join("")}
      ${compactRun ? `<text x="${w/2}" y="${floorY+46}" text-anchor="middle" class="svg-text small">${run.endGapMm}mm end gap each side</text>` : `<line x1="${railX}" y1="${floorY+44}" x2="${railX + run.endGapMm * scale}" y2="${floorY+44}" class="gap-line"/><text x="${railX + Math.max(30, run.endGapMm * scale/2)}" y="${floorY+64}" text-anchor="middle" class="svg-text small">${run.endGapMm}mm end gap</text>
      <line x1="${railEndX-run.endGapMm*scale}" y1="${floorY+44}" x2="${railEndX}" y2="${floorY+44}" class="gap-line"/><text x="${railEndX-Math.max(30, run.endGapMm*scale/2)}" y="${floorY+64}" text-anchor="middle" class="svg-text small">${run.endGapMm}mm end gap</text>`}
      <line x1="${railEndX+42}" y1="${handrailY}" x2="${railEndX+42}" y2="${fflY}" class="dim-line"/><line x1="${railEndX+34}" y1="${handrailY}" x2="${railEndX+50}" y2="${handrailY}" class="dim-line"/><line x1="${railEndX+34}" y1="${fflY}" x2="${railEndX+50}" y2="${fflY}" class="dim-line"/><text x="${railEndX+58}" y="${fflY+4}" class="svg-text small">FFL</text><rect x="${Math.min(railEndX+62, w-248)}" y="${heightBoxY}" width="206" height="42" rx="10" fill="#fbfdfc" stroke="#10201d" stroke-width="2"/><text x="${Math.min(railEndX+77, w-233)}" y="${heightBoxY+26}" fill="#10201d" font-size="14" font-weight="900">${heightLabel}</text>
      <text x="${w/2}" y="${floorY+88}" text-anchor="middle" class="svg-text strong">${baseLabel} with top handrail - ${finishLabel[state.finish]}</text>
      <text x="${w/2}" y="${floorY+112}" text-anchor="middle" class="svg-text small">${isDeck ? "Deck mount shown sitting on top of the concrete slab." : isExtended ? `Extended face plate shown as the 160mm continuous plate fixed in front of the slab, with ${extendedBalusterOverhangMm}mm baluster overhang.` : "Face mount shown fixed in front of the concrete slab."}</text>
      <text x="${w/2}" y="${floorY+134}" text-anchor="middle" class="svg-text small">50 x 10mm balusters at 100mm centres with 90mm clear openings. Top handrail and bottom mounting plate shown. Design and fixings require site review.</text>
    </svg>`;
  }

  function drawPlan(layout){
    const w = 1040;
    const h = 560;
    const cx = w / 2;
    const paths = [];
    const logicalRuns = [];
    const logicalPoints = [{x:0,y:0}];
    let x = 0;
    let y = 0;
    let angle = 0;
    layout.runs.forEach((run,index) => {
      const start = {x,y};
      const end = {
        x:x + Math.cos(angle) * run.lengthMm,
        y:y + Math.sin(angle) * run.lengthMm
      };
      logicalRuns.push({run,index,start,end,angle});
      logicalPoints.push(end);
      x = end.x;
      y = end.y;
      angle += Math.PI / 2;
    });
    const minX = Math.min(...logicalPoints.map(point => point.x));
    const maxX = Math.max(...logicalPoints.map(point => point.x));
    const minY = Math.min(...logicalPoints.map(point => point.y));
    const maxY = Math.max(...logicalPoints.map(point => point.y));
    const drawLeft = 150;
    const drawRight = w - 150;
    const drawTop = 112;
    const drawBottom = h - 132;
    const scale = Math.min(
      (drawRight - drawLeft) / Math.max(maxX - minX, 1000),
      (drawBottom - drawTop) / Math.max(maxY - minY, 1000),
      .18
    );
    const offsetX = (drawLeft + drawRight) / 2 - ((minX + maxX) / 2) * scale;
    const offsetY = (drawTop + drawBottom) / 2 - ((minY + maxY) / 2) * scale;
    const project = (point) => ({x:offsetX + point.x * scale, y:offsetY + point.y * scale});
    logicalRuns.forEach(({run,index,start,end,angle}) => {
      const p1 = project(start);
      const p2 = project(end);
      const isVertical = Math.abs(Math.sin(angle)) > .7;
      const labelX = isVertical ? p1.x - 18 : (p1.x + p2.x) / 2;
      const labelY = isVertical ? (p1.y + p2.y) / 2 : Math.min(p1.y,p2.y) - 18;
      const labelAnchor = isVertical ? "end" : "middle";
      const balusters = run.centers.map(center => {
        const point = project({
          x:start.x + Math.cos(angle) * center,
          y:start.y + Math.sin(angle) * center
        });
        return `<rect x="${point.x-4}" y="${point.y-4}" width="8" height="8" transform="rotate(${angle*180/Math.PI} ${point.x} ${point.y})" fill="#10201d"/>`;
      }).join("");
      paths.push(`<line x1="${p1.x}" y1="${p1.y}" x2="${p2.x}" y2="${p2.y}" class="plan-rail"/><text x="${labelX}" y="${labelY}" text-anchor="${labelAnchor}" class="svg-text strong">${sideLabel(index)} ${fmt(run.lengthMm)}mm</text>${balusters}`);
    });
    return `<svg viewBox="0 0 ${w} ${h}" role="img" aria-label="Visor plan drawing">
      <rect width="${w}" height="${h}" fill="#fbfdfc"/>
      <text x="${cx}" y="46" text-anchor="middle" class="title-text">${state.sideCount} side Visor aluminium plan</text>
      ${paths.join("")}
      <text x="${cx}" y="500" text-anchor="middle" class="svg-text small">Plan uses the same 100mm centre baluster positions as the BOM and elevation.</text>
      <text x="${cx}" y="524" text-anchor="middle" class="svg-text small">Start: ${endLabel(state.leftEnd)} / Final end: ${endLabel(state.rightEnd)}</text>
    </svg>`;
  }

  function draw3d(layout){
    const w = 1040;
    const h = 620;
    const runs = layout.runs;
    const heightScale = .18;
    const planPoints = [{x:0,z:0}];
    let x = 0;
    let z = 0;
    let angle = 0;
    const runModels = runs.map(run => {
      const start = {x,z};
      const end = {
        x:x + Math.cos(angle) * run.lengthMm,
        z:z + Math.sin(angle) * run.lengthMm
      };
      const centers = run.centers.map(center => ({
        x:start.x + Math.cos(angle) * center,
        z:start.z + Math.sin(angle) * center
      }));
      x = end.x;
      z = end.z;
      angle += Math.PI / 2;
      planPoints.push(end);
      return {run,start,end,centers};
    });
    const minPlanX = Math.min(...planPoints.map(point => point.x));
    const maxPlanX = Math.max(...planPoints.map(point => point.x));
    const minPlanZ = Math.min(...planPoints.map(point => point.z));
    const maxPlanZ = Math.max(...planPoints.map(point => point.z));
    const planSpan = Math.max(1000, (maxPlanX - minPlanX) + (maxPlanZ - minPlanZ));
    const planScale = Math.min(.16, 770 / planSpan);
    const rawProject = (point, y = 0) => ({
      x:(point.x - point.z * .78) * planScale,
      y:(point.x * .08 + point.z * .44) * planScale - y * heightScale
    });
    const slabPad = 320;
    const slabPoints = [
      {x:minPlanX-slabPad,z:minPlanZ-slabPad},
      {x:maxPlanX+slabPad,z:minPlanZ-slabPad},
      {x:maxPlanX+slabPad,z:maxPlanZ+slabPad},
      {x:minPlanX-slabPad,z:maxPlanZ+slabPad}
    ];
    const extentPoints = [
      ...slabPoints.map(point => rawProject(point,0)),
      ...planPoints.flatMap(point => [rawProject(point,0), rawProject(point,state.finishedHeightMm)])
    ];
    const minX = Math.min(...extentPoints.map(point => point.x));
    const maxX = Math.max(...extentPoints.map(point => point.x));
    const maxY = Math.max(...extentPoints.map(point => point.y));
    const dx = w / 2 - (minX + maxX) / 2;
    const dy = 438 - maxY;
    const project = (point, y = 0) => {
      const projected = rawProject(point,y);
      return {x:projected.x + dx, y:projected.y + dy};
    };
    const poly = (points) => points.map(point => `${point.x.toFixed(1)},${point.y.toFixed(1)}`).join(" ");
    const productFill = state.finish === "white" ? "#edf1ee" : state.finish === "mill" ? "#9ca8a4" : "#10201d";
    const productStroke = state.finish === "white" ? "#536863" : "#10201d";
    const railStroke = productFill;
    const baseStrokeWidth = state.mounting === "extended_face" ? 30 : state.mounting === "deck" ? 14 : 22;
    const facePlateLabel = state.mounting === "extended_face" ? "160mm extended face plate" : state.mounting === "face" ? "101mm face plate" : "Deck plate on slab";
    const slab = slabPoints.map(point => project(point,0));
    const bases = runModels.map(model => {
      const start = project(model.start,0);
      const end = project(model.end,0);
      return `<line x1="${start.x}" y1="${start.y}" x2="${end.x}" y2="${end.y}" stroke="${productStroke}" stroke-width="${baseStrokeWidth}" stroke-linecap="round"/>`;
    }).join("");
    const balusterBaseOffset = state.mounting === "extended_face" ? -extendedBalusterOverhangMm : 0;
    const balusters = runModels.map(model => model.centers.map(center => {
      const bottom = project(center,balusterBaseOffset);
      const top = project(center,state.finishedHeightMm - 24);
      return `<line x1="${bottom.x}" y1="${bottom.y}" x2="${top.x}" y2="${top.y}" stroke="${productStroke}" stroke-width="5" stroke-linecap="round"/>`;
    }).join("")).join("");
    const handrails = runModels.map(model => {
      const start = project(model.start,state.finishedHeightMm);
      const end = project(model.end,state.finishedHeightMm);
      return `<line x1="${start.x}" y1="${start.y}" x2="${end.x}" y2="${end.y}" stroke="${railStroke}" stroke-width="16" stroke-linecap="round"/>`;
    }).join("");
    const facePlateY = project({x:minPlanX,z:minPlanZ},0).y + 42;
    return `<svg viewBox="0 0 ${w} ${h}" role="img" aria-label="Visor 3D preview">
      <defs>
        <linearGradient id="visor3dSlab" x1="0" x2="1" y1="0" y2="1"><stop offset="0" stop-color="#eee9dc"/><stop offset="1" stop-color="#cfc8b9"/></linearGradient>
        <filter id="visor3dShadow" x="-20%" y="-20%" width="140%" height="160%"><feDropShadow dx="0" dy="12" stdDeviation="12" flood-color="#10201d" flood-opacity=".16"/></filter>
      </defs>
      <rect width="${w}" height="${h}" fill="#fbfdfc"/>
      <text x="${w/2}" y="48" text-anchor="middle" class="title-text">${state.sideCount} side ${mountingLabel[state.mounting]} 3D preview</text>
      <polygon points="${poly(slab)}" fill="url(#visor3dSlab)" stroke="#918b7f" stroke-width="2"/>
      <g filter="url(#visor3dShadow)">
        ${bases}
        ${balusters}
        ${handrails}
      </g>
      <rect x="70" y="${facePlateY}" width="250" height="44" rx="10" fill="#fff" stroke="#10201d" stroke-width="2"/>
      <text x="88" y="${facePlateY+28}" fill="#10201d" font-size="15" font-weight="900">${facePlateLabel}</text>
      <text x="${w/2}" y="546" text-anchor="middle" class="svg-text strong">${fmt(layout.totalLength)}mm total run - ${fmt(layout.totalBalusters)} balusters at 100mm centres</text>
      <text x="${w/2}" y="572" text-anchor="middle" class="svg-text small">Illustrative 3D view only. Elevation, plan and materials use the exact calculated layout.</text>
    </svg>`;
  }

  function renderCutList(layout){
    const facePlateHeight = state.mounting === "deck" ? "" : state.mounting === "extended_face" ? "160mm" : "101mm";
    return layout.runs.map(run => `
      <div class="visor-cut-card">
        <strong>Side ${run.id}: ${fmt(run.lengthMm)}mm</strong>
        <span>Base profile cuts: ${run.basePieces.map(n=>`${fmt(n)}mm`).join(", ")}</span>
        <span>Handrail cuts: ${run.handrailPieces.map(n=>`${fmt(n)}mm`).join(", ")}</span>
        ${facePlateHeight ? `<span>Face plate height: ${facePlateHeight}.</span>` : ""}
        <span>${run.balusterCount} balusters at 100mm centres; ${run.endGapMm}mm clear at each run end.</span>
        <span>Baluster cut length: ${fmt(layout.balusterCutLength)}mm.</span>
      </div>`).join("");
  }

  function renderBom(layout){
    return layout.lines.map(line => `
      <div class="visor-mat-line ${line.review ? "review" : ""}">
        <div>
          <strong>${line.label}</strong>
          <span>${line.sku}${line.variantId ? ` / variant ${line.variantId}` : " / mapping pending"}</span>
          ${line.exactQuantity ? `<p>Exact use: ${fmt(line.exactQuantity)}${line.pack ? `; pack size ${line.pack}` : ""}</p>` : ""}
          ${line.stock ? `<p>Stock length: ${fmt(line.stock)}mm</p>` : ""}
          ${line.notes.map(note=>`<p>${note}</p>`).join("")}
        </div>
        <b>x${fmt(line.quantity)}</b>
      </div>`).join("");
  }

  function renderExtrasModal(){
    const grid = $("visorExtrasGrid");
    if(!grid) return;
    const layout = calculate();
    grid.innerHTML = extras.map(([sku,description]) => {
      const product = products[sku];
      const selected = !!state.selectedExtras[sku];
      const recommendation = extraRecommendation(sku, layout.substrateFixingPlan);
      const totalPrice = product.price ? ` - ${money(product.price * recommendation.quantity)}` : "";
      return `<button type="button" class="visor-extra-card ${selected ? "selected" : ""}" data-extra="${sku}">
        <span><strong>${product.label}</strong><small>${description}</small><small>${recommendation.note}</small><small>${sku}${product.variantId ? ` / variant ${product.variantId}` : " / mapping pending"}</small></span>
        <b>${selected ? `Added x ${fmt(recommendation.quantity)}` : `Add x ${fmt(recommendation.quantity)}${totalPrice}`}</b>
      </button>`;
    }).join("");
  }

  function render(){
    if(unavailableMountings.has(state.mounting)) state.mounting = "face";
    clampHeightForMounting();
    if(!["elevation","plan","3d"].includes(state.view)) state.view = "elevation";
    const layout = calculate();
    const active = activeRun();
    const heightRule = heightRules[state.mounting] || heightRules.face;
    $("visorRunLength").value = active.lengthMm;
    $("visorProjectName").value = state.projectName;
    const heightInput = $("visorFinishedHeight");
    if(heightInput){
      heightInput.min = heightRule.min;
      heightInput.max = heightRule.max;
      heightInput.value = state.finishedHeightMm;
    }
    const heightNote = $("visorHeightNote");
    if(heightNote) heightNote.textContent = heightRule.note;
    const windNote = $("visorWindNote");
    if(windNote) windNote.textContent = windNotes[state.mounting] || windNotes.face;
    renderHeightOptions();
    const faceDropInput = $("visorFaceDrop");
    if(faceDropInput) faceDropInput.value = state.faceDropMm;

    $$("[data-field]").forEach(btn => {
      btn.classList.toggle("active", String(state[btn.dataset.field]) === String(btn.dataset.value));
    });
    $$("[data-view]").forEach(btn => btn.classList.toggle("active", state.view === btn.dataset.view));
    $("visorExtendedFields").hidden = state.mounting !== "extended_face";

    const sideButtons = $("visorSideButtons");
    sideButtons.innerHTML = sideIds.slice(0,state.sideCount).map((id,index)=>`<button type="button" class="${index===state.activeSide ? "active" : ""}" data-side-index="${index}">Side ${id}</button>`).join("");
    const preview = $("visorDrawing");
    if(state.view === "plan") preview.innerHTML = drawPlan(layout);
    else if(state.view === "3d") preview.innerHTML = draw3d(layout);
    else preview.innerHTML = drawElevation(layout);

    $("visorBom").innerHTML = renderBom(layout);
    $("visorRunSnapshot").textContent = `${fmt(layout.totalLength)}mm`;
    $("visorMountingSnapshot").textContent = mountingLabel[state.mounting];
    $("visorBalusterSnapshot").textContent = `${fmt(layout.totalBalusters)} exact`;
    $("visorProfileSnapshot").textContent = `${fmt(layout.baseProfileCount)} x 4000mm`;
    $("visorPrice").textContent = layout.validation.includes("VIS_MISSING_VARIANT") ? "Mapping review" : money(layout.price);
    $("visorCartStatus").textContent = layout.canAddToCart
      ? "Add to cart opens Optional Extras first, then Done adds the project to cart."
      : "Product mapping or layout review is required before add-to-cart.";
    $("visorAddToCart").disabled = !layout.canAddToCart;
    $("visorWarnings").innerHTML = layout.validation.map(code => `<li><strong>${code}</strong> ${warningText(code)}</li>`).join("");
    renderExtrasModal();
    window.GHA_VISOR_LAST_LAYOUT = layout;
  }

  function warningText(code){
    const messages = {
      VIS_COMPLIANCE_REVIEW:"This tool plans products only. NCC 2022, AS/NZS 1170.0, 1170.1, 1170.2 and AS/NZS 1664.1 compliance must be checked for the site.",
      VIS_MISSING_VARIANT:"One or more required products does not yet have a verified live Shopify variant mapping.",
      VIS_UNVERIFIED_CUTTING_WORKFLOW:"Extended balusters need a confirmed cutting, labelling, packing and waste workflow.",
      VIS_UNVERIFIED_SCREW_QUANTITY:"Extended face-plate screw role/quantity needs final product review before cart.",
      VIS_HEIGHT_REVIEW:"The finished barrier height is outside the documented range for the selected mounting configuration.",
      VIS_UNVERIFIED_FIXING:"Selected Extras are fixing products; suitability, embedment and supporting structure must be confirmed.",
      VIS_INVALID_BALUSTER_SPACING:"Baluster centres must remain exactly 100mm.",
      VIS_OVERSIZED_OPENING:"Clear openings must remain 90mm between balusters.",
      VIS_UNSUPPORTED_END_CLEARANCE:"Run end clearance is outside the supported opening range."
    };
    return messages[code] || "Review required.";
  }

  function saveProject(){
    localStorage.setItem("gha_visor_aluminium_project", JSON.stringify(state));
    $("visorCartStatus").textContent = "Visor project saved in this browser.";
  }

  function loadProject(){
    const raw = localStorage.getItem("gha_visor_aluminium_project");
    if(!raw){
      $("visorCartStatus").textContent = "No saved Visor project found in this browser.";
      return;
    }
    try{
      Object.assign(state, JSON.parse(raw));
      render();
      $("visorCartStatus").textContent = "Saved Visor project loaded.";
    } catch(error){
      $("visorCartStatus").textContent = "Saved project could not be loaded.";
    }
  }

  function shareProject(){
    const url = new URL(window.location.href);
    url.hash = `visor=${encodeURIComponent(JSON.stringify(state))}`;
    navigator.clipboard?.writeText(url.toString()).then(()=>{
      $("visorCartStatus").textContent = "Share link copied to clipboard.";
    }).catch(()=>{
      $("visorCartStatus").textContent = url.toString();
    });
  }

  function printDesign(){
    window.print();
  }

  function requestQuote(){
    const layout = calculate();
    const subject = encodeURIComponent("Visor aluminium balustrade quote request");
    const body = encodeURIComponent([
      state.projectName,
      `${mountingLabel[state.mounting]} / ${finishLabel[state.finish]}`,
      `${state.sideCount} side layout / ${fmt(layout.totalLength)}mm total`,
      "",
      "BOM:",
      ...layout.lines.map(line => `${line.quantity} x ${line.sku} - ${line.label}`),
      "",
      "Warnings:",
      ...layout.validation
    ].join("\n"));
    window.location.href = `mailto:sales@glasshouseau.com?subject=${subject}&body=${body}`;
  }

  function openExtrasModal(){
    const modal = $("visorExtrasModal");
    modal.classList.add("open");
    modal.setAttribute("aria-hidden", "false");
    renderExtrasModal();
  }

  function closeExtrasModal(){
    const modal = $("visorExtrasModal");
    modal.classList.remove("open");
    modal.setAttribute("aria-hidden", "true");
  }

  function buildCartItems(layout){
    const grouped = new Map();
    layout.lines.forEach(line => {
      if(!line.variantId || line.quantity < 1) return;
      const key = String(line.variantId);
      const existing = grouped.get(key) || {
        id:line.variantId,
        quantity:0,
        properties:{
          "_Configurator":"Visor aluminium",
          "_Project":state.projectName,
          "_SKU":line.sku,
          "_Item":line.label
        }
      };
      existing.quantity += line.quantity;
      if(line.notes.length){
        existing.properties["_Notes"] = [existing.properties["_Notes"], ...line.notes].filter(Boolean).join(" | ");
      }
      if(line.exactQuantity){
        existing.properties["_Exact use"] = fmt(line.exactQuantity);
      }
      grouped.set(key, existing);
    });
    return Array.from(grouped.values());
  }

  async function addConfiguredProjectToCart(){
    const layout = calculate();
    if(!layout.canAddToCart){
      $("visorCartStatus").textContent = layout.cartBlockingValidation.length
        ? `Cannot add yet: ${layout.cartBlockingValidation.join(", ")}.`
        : "Cannot add this configuration to cart yet.";
      return;
    }
    const items = buildCartItems(layout);
    if(!items.length){
      $("visorCartStatus").textContent = "No mapped products were available to add.";
      return;
    }
    $("visorCartStatus").textContent = "Adding Visor project to cart...";
    try{
      const response = await fetch("/cart/add.js", {
        method:"POST",
        headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({items})
      });
      if(!response.ok){
        const errorText = await response.text();
        throw new Error(errorText || `Cart request failed with ${response.status}`);
      }
      closeExtrasModal();
      $("visorCartStatus").textContent = "Added to cart. Opening cart...";
      window.location.href = "/cart";
    } catch(error){
      $("visorCartStatus").textContent = `Cart add failed: ${error.message || error}`;
    }
  }

  function bind(){
    root.addEventListener("click",(event)=>{
      const fieldBtn = event.target.closest("[data-field]");
      if(fieldBtn && root.contains(fieldBtn)){
        if(fieldBtn.disabled || fieldBtn.dataset.unavailable === "true" || fieldBtn.getAttribute("aria-disabled") === "true") return;
        const field = fieldBtn.dataset.field;
        const value = fieldBtn.dataset.value;
        if(field === "sideCount"){
          state.sideCount = Number(value);
          state.activeSide = Math.min(state.activeSide, state.sideCount - 1);
        } else {
          const previousValue = state[field];
          state[field] = value;
          if(field === "mounting"){
            if(value === "extended_face" && previousValue !== value) state.finishedHeightMm = heightRules.extended_face.max;
            clampHeightForMounting();
          }
        }
        render();
        return;
      }
      const viewBtn = event.target.closest("[data-view]");
      if(viewBtn && root.contains(viewBtn)){
        state.view = viewBtn.dataset.view;
        render();
        return;
      }
      const heightBtn = event.target.closest("[data-height-option]");
      if(heightBtn && root.contains(heightBtn) && !heightBtn.disabled){
        state.finishedHeightMm = Number(heightBtn.dataset.heightOption);
        render();
        return;
      }
      const sideBtn = event.target.closest("[data-side-index]");
      if(sideBtn && root.contains(sideBtn)){
        state.activeSide = Number(sideBtn.dataset.sideIndex);
        render();
        return;
      }
      const extraBtn = event.target.closest("[data-extra]");
      if(extraBtn && root.contains(extraBtn)){
        const sku = extraBtn.dataset.extra;
        state.selectedExtras[sku] = !state.selectedExtras[sku];
        render();
      }
    });

    $("visorRunLength").addEventListener("input",(event)=>{
      state.runs[state.activeSide].lengthMm = Number(event.target.value || 0);
      render();
    });
    $("visorProjectName").addEventListener("input",(event)=>{ state.projectName = event.target.value; });
    $("visorFinishedHeight")?.addEventListener("input",(event)=>{ state.finishedHeightMm = Number(event.target.value || 0); render(); });
    $("visorFaceDrop")?.addEventListener("input",(event)=>{ state.faceDropMm = Number(event.target.value || 0); render(); });
    $("visorSave").addEventListener("click", saveProject);
    $("visorLoad").addEventListener("click", loadProject);
    $("visorShare").addEventListener("click", shareProject);
    $("visorPrint").addEventListener("click", printDesign);
    $("visorQuote").addEventListener("click", requestQuote);
    $("visorExtrasOpen")?.addEventListener("click", openExtrasModal);
    $("visorExtrasClose").addEventListener("click", closeExtrasModal);
    $("visorExtrasDone").addEventListener("click", addConfiguredProjectToCart);
    $("visorAddToCart").addEventListener("click",()=>{
      if($("visorAddToCart").disabled) return;
      openExtrasModal();
      $("visorCartStatus").textContent = "Choose optional extras, then press Done to add the project to cart.";
    });
  }

  function loadHash(){
    if(!window.location.hash.includes("visor=")) return;
    try{
      const raw = window.location.hash.split("visor=")[1];
      Object.assign(state, JSON.parse(decodeURIComponent(raw)));
    } catch(error){}
  }

  window.GHA_VISOR = { calculate, products, state };
  loadHash();
  bind();
  render();
})();
